import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";

export default function DichiarazioneMensile() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8" data-testid="dichiarazione-mensile-page">
      <div className="flex items-center gap-3">
        <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-bordeaux text-white">
          <CalendarCheck className="h-6 w-6" />
        </span>
        <h1 className="section-title">Dichiarazione Mensile</h1>
      </div>
      <p className="mt-4 text-muted-foreground">
        Cosa si intende per dichiarazione mensile e perché conta per chi si esibisce nel mondo dello spettacolo.
      </p>
      <div className="mt-8 space-y-8">
        <section>
          <h2 className="font-heading text-xl font-semibold text-bordeaux-dark">Cos'è la dichiarazione mensile</h2>
          <div className="mt-3 space-y-3 text-base leading-relaxed text-foreground/80">
            <p>
              La <strong className="text-bordeaux">dichiarazione mensile</strong> è l'adempimento con cui, con cadenza
              mensile, vengono comunicate all'ente previdenziale le prestazioni lavorative rese nell'ambito dello
              spettacolo: date delle esibizioni, locali o eventi, compensi corrisposti agli artisti e agli altri
              lavoratori impiegati.
            </p>
            <p>
              In pratica è il "riepilogo del mese" dell'attività artistica: serve a registrare ufficialmente il
              lavoro svolto e costituisce la base per il calcolo e il versamento dei contributi previdenziali dovuti.
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-heading text-xl font-semibold text-bordeaux-dark">Perché è importante per gli artisti</h2>
          <div className="mt-3 space-y-3 text-base leading-relaxed text-foreground/80">
            <p>
              Dalla dichiarazione mensile dipende la <strong className="text-bordeaux">regolarità della posizione
              previdenziale</strong> di cantanti, musicisti, D.J. e lavoratori dello spettacolo: i contributi che ne
              derivano contano ai fini della pensione e delle tutele previste per chi lavora in questo settore.
            </p>
            <p>
              Una gestione puntuale e corretta della dichiarazione evita ritardi, irregolarità e problemi futuri, e
              permette all'artista di avere sempre un quadro chiaro della propria situazione.
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-heading text-xl font-semibold text-bordeaux-dark">Come può aiutarti ENPALSBOX</h2>
          <div className="mt-3 space-y-3 text-base leading-relaxed text-foreground/80">
            <p>
              Obblighi, tempistiche e modalità possono variare a seconda del tipo di attività e di collaborazione.
              Se hai dubbi su cosa si applica al tuo caso, <strong className="text-bordeaux">contatta ENPALSBOX:</strong>{" "}
              il nostro team è a tua disposizione per aiutarti a orientarti tra gli adempimenti legati alle tue
              prestazioni artistiche.
            </p>
          </div>
        </section>
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/contatti" data-testid="dichiarazione-contact-btn" className="btn-bordeaux">CONTATTA ENPALSBOX</Link>
        <Link to="/iscriviti" data-testid="dichiarazione-register-btn" className="btn-outline-bordeaux">ISCRIVITI</Link>
      </div>
    </div>
  );
}
